"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.codePointsToStringUnmapper = exports.codePointsToStringMapper = void 0;

function codePointsToStringMapper(tab) {
  return tab.join('');
}

exports.codePointsToStringMapper = codePointsToStringMapper;

function codePointsToStringUnmapper(value) {
  if (typeof value !== 'string') {
    throw new Error('Cannot unmap the passed value');
  }

  return _toConsumableArray(value);
}

exports.codePointsToStringUnmapper = codePointsToStringUnmapper;